import { GenericService } from '../GenericService'

class UserGuestsService extends GenericService {
    constructor() {
        super('/api/guests')
    }

    getSingleRecord = (id) => this.get('/api/admin/question/single/' + id)
    deleteRecord = (data) => this.post('/api/guests/delete', data)
    getCompanyQuestions = (data) =>
        this.post('/api/admin/question/getCompanyQuestions', data)
    markAsFirst = (data) => this.post('/api/admin/question/markAsFirst', data)
}

export default new UserGuestsService()
